import React from 'react';
export function StartFreeFAQHeader() {
  return <h2 className="text-4xl text-ink text-center mb-12" data-id="element-3082">Common Questions</h2>;
}